import React, { Component } from "react";
import { connect } from 'react-redux';
import renderHTML from 'react-render-html';
import htmlTagValidator from 'html-tag-validator'
import Swal from 'sweetalert2'
import { NavigationHeader } from "../../layout/components/navigationheader/NavigationHeader";
import { Card, Button, Container, Row, Col, Form } from 'react-bootstrap';
import { saveShortcode } from '../../../../../../../actions/sceneActions'
import { SHORT_CODE_SUCCESS_SAVE, SUCCESS_TEXT } from '../../../app/messageText'
import { customClass, getInitialRoute } from '../../../../../../../utils'

class UpdateShortCode extends Component {
    state = {
        shortcode: null,
        shortcodePreview: null,
        buttonDis:false,
        loader:false,
        stateChanged:false
    }
    onTextShortCode = event => {
        this.setState({ shortcode: event.target.value,stateChanged:true }, () => this.htmlRender())
    }
    onSaveShortCode = event => {
        const { param } = this.props;
        const { shortcode } = this.state;

       if(shortcode){
         this.setState({loader:true, buttonDis:true})
         this.props.saveShortcode(param.contentMixId, param.positionID, shortcode, this.onSaveCallBack)
           }else{
            Swal.fire({
                title: 'Error',
                text: 'Please enter Short Code!',
                type: "error",
                icon: 'error',
                showConfirmButton: false,
                timer: 3000
              });
        }
    }

    onBack = event => {
        const { params } = this.props.match;
        const { shortcode } = this.state;

            if (!this.state.stateChanged) {
                this.props.history(`/studio/${params.wallId}`)
                return;
            }
            
        if (shortcode) {
            Swal.fire({
                title: "Are you sure?",
                text: "Your changes have not been saved. Do you want to save before you leave the page?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Save",
                cancelButtonText: "Discard Changes",
                reverseButtons: true,
                customClass: customClass
            }).then((result) => {
                if (result.value) {
                    this.onSaveShortCode()
                } else if (result.dismiss === "cancel") {
                    this.props.history(`/studio/${params.wallId}`)

                }
            });
        }
        else {
            this.props.history(`/studio/${params.wallId}`)
        }

    }
    onSaveCallBack = () => {
        const { params } = this.props.match;
        Swal.fire({
            title: SUCCESS_TEXT,
            text: SHORT_CODE_SUCCESS_SAVE,
            type: "success",
            icon: 'success',
            showConfirmButton: false,
            timer: 3000
        }
        ).then((result) => {
            this.setState({loader:false, buttonDis:false})
            this.props.history(`/studio/${params.wallId}`)
        })

    }
    htmlRender = () => {
        const { shortcode } = this.state;
        try {
            htmlTagValidator(shortcode, (err, ast) => {
                if (err) {
                    this.setState({ shortcodePreview: null })
                    throw err;
                } else {
                    this.setState({ shortcodePreview: shortcode })
                }
            });

        }
        catch (ex) {
            return ""
        }
    }

    render() {
        const { match } = this.props;
        const { shortcode,buttonDis,loader, shortcodePreview } = this.state;
        return (<div>
            <NavigationHeader name="Short Code" backToNavigation={`/studio/${match.params.wallId}`} />
            <div className="container-fluid subheader_content">
                <Card className="select_wall mb-3 rounded-0 border-0">
                    <Card.Body className="p-0">
                        <Row>
                            <Col lg={4} className="border-right-lg">
                                <Card className="border-0 rounded-0">
                                    <Card.Body className="p-4 card_height">
                                        <Form>
                                            <Form.Group controlId="formBasicEmail">
                                                <Form.Label>Enter Shortcode</Form.Label>
                                                <Form.Control as="textarea" rows={6} className="text-url-update form-control-solid" onChange={this.onTextShortCode} placeholder="<div>www.taggbox.com</div> " />
                                            </Form.Group>
                                        </Form>
                                    </Card.Body>
                                    <Card.Footer className="bg-transparent d-flex justify-content-end border-0 p-4">
                                        <button className="btn btn-outline-dark me-3 btn-min-w" onClick={this.onBack}><span className="position-relative">Back</span></button>
                                        <Button disabled={ buttonDis } variant="primary" className={`btn btn-primary btn-min-w ${loader ? `spinner spinner-white spinner-right disabled` : null}`} onClick={this.onSaveShortCode}>Save</Button>
                                    </Card.Footer>
                                </Card>

                            </Col>
                            <Col lg={8} className="d-flex align-items-center justify-content-center">
                                <Card className="border-0 card w-100">
                                    <Card.Body className="border-0">
                                        <div className="wall_view">
                                            <div className="wall_view_wrapper">
                                                {/* wall component */}
                                                {
                                                    shortcodePreview && renderHTML(shortcodePreview)
                                                }
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                    </Card.Body>
                </Card>

            </div>
        </div>);
    }
}

const mapStateToProps = state => {
    return {
        studioWall: state.studio.studioWall
    }
}
const mapDispatchToProps = dispatch => {
    return {
        saveShortcode: (contentMixId, positionID, shortCode, callBack) => dispatch(saveShortcode(contentMixId, positionID, shortCode, callBack)),
    }
}



export default connect(mapStateToProps, mapDispatchToProps)(UpdateShortCode);